<template>
  <div>
    <div class="hidden-xs-only">
      <!-- <div class="title">{{$t('modelSlogan.title')}}</div>
      <div class="desc">{{$t('modelSlogan.desc')}}</div> -->
      <div class="slogan-box">
        <div class="image-box">
          <img
            src="../../assets/images/homeAfter/model-slogan.png"
            alt="slogan"
          />
        </div>
        <div class="info-box">
          <div>
            <div class="slogan">
              {{ $t("modelSlogan.slogan") }}<br />{{
                $t("modelSlogan.slogan2")
              }}
            </div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc1") }}</div>
          </div>
          <div class="slogan-btn">
            <span>{{ $t("modelSlogan.slogan-btn") }}</span>
            <div class="line"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden-sm-and-up">
      <div class="slogan-box">
        <div class="info-box">
          <div class="slogan">
            {{ $t("modelSlogan.slogan") }}<br />{{ $t("modelSlogan.slogan2") }}
          </div>
          <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc1") }}</div>
          <div class="slogan-btn">{{ $t("modelSlogan.slogan-btn") }}</div>
        </div>
        <div class="image-box">
          <img
            src="../../assets/images/homeAfter/model-slogan-mobile.png"
            alt="slogan"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.hidden-xs-only {
  overflow: hidden;
  .slogan-box {
    margin-top: 99px;
    margin-bottom: 35px;
    text-align: left;
    .image-box {
      display: inline-block;
      width: 780px;
      margin-left: 180px;
      margin-right: 75px;
      vertical-align: top;
      @media (max-width: 1600px) {
        width: 600px;
      }
      @media (max-width: 1300px) {
        width: 400px;
      }
      > img {
        display: block;
        width: 100%;
      }
    }
    .info-box {
      display: inline-flex;
      width: 540px;
      height: 520px;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;
      vertical-align: top;
      @media (max-width: 1600px) {
        width: 420px;
        height: 400px;
      }
      @media (max-width: 1300px) {
        width: 300px;
        height: 280px;
      }
      .slogan {
        margin-bottom: 50px;
        font-size: 90px;
        color: #333;
        font-weight: 700;
        @media (max-width: 1600px) {
          margin-bottom: 20px;
          font-size: 60px;
        }
        @media (max-width: 1300px) {
          margin-bottom: 16px;
          font-size: 30px;
        }
      }
      .slogan-desc {
        font-size: 18px;
        color: #555;
        line-height: 26px;
        @media (max-width: 1600px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
      .slogan-btn {
        position: relative;
        width: 157px;
        line-height: 46px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        background-color: #13b0b9;
        cursor: pointer;
        .line {
          position: absolute;
          right: calc(100% + 5px);
          top: 50%;
          height: 1px;
          width: 105px;
          background-color: #13b0b9;
          &::after {
            content: "";
            position: absolute;
            left: -9px;
            top: -4px;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background-color: #13b0b9;
          }
        }
      }
    }
  }
}
.hidden-sm-and-up {
  overflow: hidden;
  padding: 0 25px;
  text-align: left;
  .slogan-box {
    margin-top: 60px;
    margin-bottom: 60px;
    .info-box {
      margin-bottom: 30px;
      .slogan {
        margin-bottom: 20px;
        font-size: 30px;
        font-weight: 700;
        line-height: 36px;
      }
      .slogan-desc {
        margin-bottom: 20px;
        font-size: 12px;
        color: #555;
        line-height: 20px;
      }
      .slogan-btn {
        width: 140px;
        line-height: 40px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background-color: #13b0b9;
        cursor: pointer;
      }
    }
    .image-box {
      > img {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>